var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 43,
    viewBox: "0 0 72 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 71.25,
    height: 38.1161,
    rx: 14.625,
    stroke: "#7E7E8F",
    strokeWidth: 0.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.3779,
    y: 15,
    width: 0.654761,
    height: 15.3869,
    fill: "#7E7E8F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.6875,
    y: 15,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32.8333,
    y: 16.146,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 35.125,
    y: 16.146,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4165,
    y: 16.146,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7085,
    y: 16.146,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 31.6875,
    y: 17.2915,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 31.6875,
    y: 19.583,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 32.8333,
    y: 18.4375,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 36.2708,
    y: 19.583,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 35.125,
    y: 18.4375,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 33.979,
    y: 19.583,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5627,
    y: 19.583,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 40.8542,
    y: 19.583,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4165,
    y: 18.4375,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7085,
    y: 18.4375,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 36.2708,
    y: 21.8745,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 35.125,
    y: 20.729,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 32.8333,
    y: 20.729,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 36.2708,
    y: 17.2915,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 31.6875,
    y: 21.8745,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 36.2708,
    y: 15,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 33.979,
    y: 21.8745,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5627,
    y: 21.8745,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 40.8542,
    y: 21.8745,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4165,
    y: 20.729,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7085,
    y: 20.729,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 33.979,
    y: 17.2915,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5627,
    y: 17.2915,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 40.8542,
    y: 17.2915,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 33.979,
    y: 15,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5627,
    y: 15,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 40.8542,
    y: 15,
    width: 1.14583,
    height: 1.14583,
    fill: "#7E7E8F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.811,
    cy: 38.677,
    r: 3.21555,
    fill: "#3C404E",
    stroke: "#7E7E8F",
    strokeWidth: 0.75
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/track.d59fd608a2cb6615a858419d2d2bf0be.svg";
export { ForwardRef as ReactComponent };